export const environment = {
  production: false,
  apiUrl: 'https://admin-api.amlpshop.rikkeidigital.asia',
  googleMapKey: 'AIzaSyCpVhQiwAllg1RAFaxMWSpQruuGARy0Y1k'
};
